import { Component } from '@angular/core';

@Component({
  selector: 'wpro-trusted-device',
  templateUrl: './trusted-device.component.html',
  styleUrls: ['./trusted-device.component.css'],
  standalone: false
})
export class TrustedDeviceComponent {
  showMessage: boolean;

  constructor() { }

  isAPIFailLoginScreen(event: boolean): void {
    this.showMessage = event;
  }
}
